import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { INoahDeviceInventoryItemMapDetail } from 'gen/ApiClient';
import { calcPatientDetailRoute } from 'app/main/patients/calcPatientDetailRoute';
import { XViewBadgeIconButton } from 'shared/icons/XViewBadgeIconButton';

interface IProps {
	item: INoahDeviceInventoryItemMapDetail;
}

export const PatientFromInventoryItemHeader = ({ item }: IProps) => {
	const { push } = useHistory();

	if (item.hasPatientFromInventoryItem) {
		return (
			<div className='df-row-ac'>
				<div>{item.patientFromInventoryItem!.identifier}</div>
				<XViewBadgeIconButton
					size='small'
					onClick={() => push(calcPatientDetailRoute(item.patientFromInventoryItem!.id!))}>
					<PersonOutlineOutlinedIcon fontSize='small' />
				</XViewBadgeIconButton>
			</div>
		);
	} else {
		return <></>;
	}
};
